import React, { useState } from "react";
import { Col, ControlLabel, FormControl, Row } from 'react-bootstrap';
import { useTranslation } from "react-i18next";
import medicalPractitioner from "../../../api/medicalPractitioner";
import AutoCompletation from "../../../components/Common/AutoCompletation";
import { Add } from "../../../components/Icons/Icons";
import { Tooltip } from "../../../components/Utils/Tooltips";

export default function SearchOrAddMedicalPractitioner({ practitioner, onChange, onBlur, name }) {
    const [searchMedical, setSearchMedical] = useState(true)
    //const [selectedPractitioner, setSelectedPractitioner] = useState(practitioner ?? { id: null, fullName: null, identificationNumber: null, practitionerId: null })

    const onHandleSelectPractitioner = (practitioner) => {
        //setSelectedPractitioner(practitioner)
        onChange(name, practitioner)
    }

    return (<>
        {searchMedical
            ? <SearchMedicalPractitioner onChange={onHandleSelectPractitioner} name={name} onHandleNew={setSearchMedical} onBlur={onBlur} />
            : <AddMedicalPractitioner onSubmit={onHandleSelectPractitioner} onHandleSearch={setSearchMedical} />}
    </>)

}

function FormGroup({ children }) {
    return (<div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
        {children}
    </div>)
}

function SearchMedicalPractitioner({ name, onHandleNew, onBlur, onChange }) {
    const { t } = useTranslation();

    const fetchMedicalPractitioners = async (term) => {
        const result = await medicalPractitioner.find({ term: term })
        return result;
    }

    const handleOnChange = (selected) => {
        const value = selected == null || selected.length == 0
            ? null :
            selected[0];

        onChange(value)
    }

    return (<div style={{ display: 'flex', justifyContent: 'start', alignItems: 'center', gap: '1rem' }}>
        <FormGroup>
            <ControlLabel>{t('protocols.practitioner.practitioner')}</ControlLabel>
            <AutoCompletation
                name={name}
                placeholder={t("commons.userSearch")}
                labelKey={option => `${option.fullName} - ${option.identificationNumber}`}
                fetchOptions={fetchMedicalPractitioners}
                onChange={handleOnChange}
                onBlur={onBlur}
            />
        </FormGroup>

        <button style={{ alignSelf: 'end' }} type="button" className="btn btn-success" onClick={() => onHandleNew(false)}>
            <Tooltip tooltip={t('protocols.practitioner.addExternalPractitioner')}>
                <Add />
            </Tooltip>
        </button>
    </div>
    )
}
function AddMedicalPractitioner({ onSubmit, onHandleSearch }) {
    const { t } = useTranslation();
    const [externalPractitioner, setExternalPractitioner] = useState({
        fullName: '',
        identificationNumber: ''
    })
    const [isSubmit, setSubmit] = useState(false);

    const handleCancel = () => {
        if (isSubmit)
            setSubmit(false)
        else
            onHandleSearch(true)
    }

    const handleSubmit = () => {
        setSubmit(true)
        onSubmit(externalPractitioner)
    }

    const practitionerIsEmpty = (practitioner) => {
        return practitioner.fullName == null
            || practitioner.identificationNumber == null
            || practitioner.fullName.trim() == ''
            || practitioner.identificationNumber.trim() == ''
    }

    return (<FormGroup>
        <div>
            <label>{t('protocols.practitioner.addExternalPractitioner')}</label>
        </div>
        <Row>
            <Col sm={12} md={6}>
                <FormGroup>
                    <ControlLabel>{t('protocols.practitioner.fullName')}</ControlLabel>
                    <FormControl
                        type="text"
                        disabled={isSubmit}
                        value={externalPractitioner.fullName}
                        onChange={e => setExternalPractitioner({ ...externalPractitioner, fullName: e.target.value })}
                    />
                </FormGroup>
            </Col>
            <Col sm={12} md={6}>
                <FormGroup>
                    <ControlLabel>{t('protocols.practitioner.identificationNumber')}</ControlLabel>
                    <FormControl
                        type="text"
                        disabled={isSubmit}
                        value={externalPractitioner.identificationNumber}
                        onChange={e => setExternalPractitioner({ ...externalPractitioner, identificationNumber: e.target.value })}
                    />
                </FormGroup>
            </Col>
        </Row>
        <div style={{ display: 'flex', gap: '1rem' }}>
            <button type="button" className="btn btn-default" onClick={handleCancel}>{t('buttons.cancel')}</button>
            <button type="button" disabled={isSubmit || practitionerIsEmpty(externalPractitioner)} className="btn btn-success" onClick={handleSubmit}>{t('buttons.apply')}</button>
        </div>
    </FormGroup>);
}